import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export default createAsyncThunk(
  'publishEntity/updatePublishStatusAction',
  async ({ entityType, entityId, isPublished }, { rejectWithValue }) => {
    try {
      const response = await axios.patch('/admin/publish', {
        EntityType: entityType,
        EntityId: entityId,
        IsPublished: isPublished,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);
